export const LD_APP_NAME = 'client-web-portal';
export const LD_FALLBACK_CLIENT_ID = 'unconfigured';

export function getLDClientId() {
  const clientId = process.env.REACT_APP_LD_CLIENT_ID;
  if (!clientId) {
    return '';
  }
  return clientId.trim();
}

export function getLDEnv() {
  const env = process.env.REACT_APP_LD_ENV;
  if (!env) {
    return '';
  }
  return env.trim();
}

export function isLDConfigured() {
  return getLDClientId() !== '';
}
